import * as React from 'react';
import {useContext, useEffect, useState} from 'react';
import {DatePicker, DefaultButton, Panel, PrimaryButton, SpinButton, Stack, TextField, Toggle} from '@fluentui/react';
import AuthContext from "../../Services/AuthContext";
import {dbDate} from "../../Utilities/dbDate";
import NetGrossPicker from "../../Components/NetGrossPicker";

function EditTransaction(props) {
    const [user] = useContext(AuthContext);
    const [date, setDate] = useState('');
    const [transactionDate, setTransactionDate] = useState('');
    const [transferDate, setTransferDate] = useState('');
    const [finalizationDate, setFinalizationDate] = useState('');
    const [until, setUntil] = useState('');
    const [reservationNumber, setReservationNumber] = useState('');
    const [transactionNumber, setTransactionNumber] = useState('');
    const [net, setNet] = useState(0);
    const [vat, setVat] = useState(0);
    const [gross, setGross] = useState(0);
    const [overwriteSchedule, setOverwriteSchedule] = useState(false);

    const [finalizationNumber, setFinalizationNumber] = useState('')
    const [finalDivider, setFinalDivider] = useState('')
    const [shares, setShares] = useState('')

    const _submit = (e) => {
        e.preventDefault();
        const data = {
            reservation_date: dbDate(date),
            net_value: net,
            vat: vat,
            gross_value: gross,
            until: dbDate(until),
            reservation_number: reservationNumber === '' ? null : reservationNumber,
            transaction_number: transactionNumber === '' ? null : transactionNumber,
            transaction_date: dbDate(transactionDate),
            transfer_date: dbDate(transferDate),
            finalization_date: dbDate(finalizationDate),
            overwrite_schedule: overwriteSchedule,
            finalization_number: finalizationNumber === '' ? null : finalizationNumber,
            shares: shares === '' ? null : shares,
            final_divider: finalDivider === '' ? null : finalDivider,
        };
        fetch(`/api/transaction/${props.edit.id}`, {
            method: 'PUT',
            body: JSON.stringify(data),
            headers: {
                'Authorization': 'Bearer ' + user.token
            }
        }).then(res => res.json())
            .then(json => { props.onSuccess(json); props.dismissPanel(); })
            .catch(err => { console.log(err) })
    }

    const footer = React.useCallback(() => (<Stack horizontal horizontalAlign='space-between'>
        <PrimaryButton type='submit' form='EditTransaction'>Edytuj</PrimaryButton>
        <DefaultButton onClick={props.dismissPanel}>Anuluj</DefaultButton>
    </Stack>), [props.dismissPanel]);

    useEffect(() => {
        setDate(props.edit.reservation_date !== null ? new Date(props.edit.reservation_date) : '');
        setTransactionDate(props.edit.transaction_date !== null ? new Date(props.edit.transaction_date) : '');
        setTransferDate(props.edit.transfer_date !== null ? new Date(props.edit.transfer_date) : '');
        setFinalizationDate(props.edit.finalization_date !== null ? new Date(props.edit.finalization_date) : '');
        setUntil(props.edit.until !== null ? new Date(props.edit.until) : '');
        setNet(props.edit.net_value ?? 0);
        setVat(props.edit.vat ?? 0);
        setGross(props.edit.gross_value ?? 0);
        setReservationNumber(props.edit.reservation_number ?? '');
        setTransactionNumber(props.edit.transaction_number ?? '');
        setShares(props.edit.shares ?? '')
        setFinalizationNumber(props.edit.finalization_number ?? '')
        setFinalDivider(props.edit.final_divider ?? '');
    }, [props.edit])

    return (
        <Panel
            isOpen={props.edit}
            onDismiss={props.dismissPanel}
            headerText="Edytuj Transakcję"
            closeButtonAriaLabel="Close"
            onRenderFooterContent={footer}
            isFooterAtBottom={true}
        >
            <form onSubmit={_submit} id='EditTransaction'>
                <TextField autoFocus label='Numer Rezerwacji' value={reservationNumber} onChange={(e) => setReservationNumber(e.target.value || '')}/>
                <TextField
                    label={"Numer aktu przeniesienia własności"}
                    onChange={(e) => setFinalizationNumber(e.target.value || '')}
                    value={finalizationNumber}
                />
                <TextField
                    label={"Udział w nieruchomości wspólnej"}
                    onChange={(e) => setShares(e.target.value || '')}
                    value={shares}
                />
                <SpinButton
                    label={'Powierzchnia powykonawcza:'}
                    labelPosition={'top'}
                    min={0.0001}
                    step={0.0001}
                    max={10000000000}
                    incrementButtonAriaLabel={'Increase value by 1'}
                    decrementButtonAriaLabel={'Decrease value by 1'}
                    value={finalDivider}
                    onChange={(e) => setFinalDivider(e.target.value || '')}
                />

                <DatePicker
                    label="Data Rezerwacji"
                    isRequired={true}
                    placeholder="Wybierz datę..."
                    ariaLabel="Wybierz datę"
                    value={date}
                    onSelectDate={(e) => setDate(e || '')}
                />
                <DatePicker
                    label="Termin Umowy"
                    isRequired={true}
                    placeholder="Wybierz datę..."
                    ariaLabel="Wybierz datę"
                    value={until}
                    onSelectDate={(e) => setUntil(e || '')}
                />
                <NetGrossPicker net={net} setNet={setNet} gross={gross} setGross={setGross} vat={vat} setVat={setVat} />
                <TextField label='Numer Transakcji' value={transactionNumber} onChange={(e) => setTransactionNumber(e.target.value || '')}/>
                <DatePicker
                    label="Data Transakcji"
                    placeholder="Wybierz datę..."
                    ariaLabel="Wybierz datę"
                    value={transactionDate}
                    onSelectDate={(e) => setTransactionDate(e || '')}
                />
                <DatePicker
                    label="Data Przekazania"
                    placeholder="Wybierz datę..."
                    ariaLabel="Wybierz datę"
                    value={transferDate}
                    onSelectDate={(e) => setTransferDate(e || '')}
                />
                <DatePicker
                    label="Data Finalizacji Umowy"
                    placeholder="Wybierz datę..."
                    ariaLabel="Wybierz datę"
                    value={finalizationDate}
                    onSelectDate={(e) => setFinalizationDate(e || '')}
                />
                <Toggle label="Nadpisz Harmonogram Płatności" defaultChecked={false} onText="Tak" offText="Nie" onChange={(e, checked) => setOverwriteSchedule(checked)} />
            </form>
        </Panel>
    )
}

export default EditTransaction;